import { render } from "./FaqHero.vue?vue&type=template&id=fe1bedfc&scoped=true"
import script from "./FaqHero.vue?vue&type=script&lang=js"
export * from "./FaqHero.vue?vue&type=script&lang=js"

import "./FaqHero.vue?vue&type=style&index=0&id=fe1bedfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1bedfc"]])

export default __exports__